import {SxType} from "@baseTypes/sx/sxTypes";
import {
    SV_DARK,
    SV_LIGHT,
    SV_RADIUS_MD,
    SV_TRANSITION,
    svPressable
} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        boxShadow: 'none',
        padding: '7px 18px',
        borderRadius: SV_RADIUS_MD,
        border: '1px solid',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '18px',
        letterSpacing: 0,
        textTransform: 'none',
        minWidth: '140px',
        minHeight: 'auto',
        transition: SV_TRANSITION,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surface,
            borderColor: SV_LIGHT.lineStrong,
            color: SV_LIGHT.text,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surface,
            borderColor: SV_DARK.lineStrong,
            color: SV_DARK.text,
        },
        ...svPressable,
        '&:hover': {
            ...svPressable['&:hover'],
            '.lightTheme &': {
                backgroundColor: SV_LIGHT.surfaceMuted,
                borderColor: SV_LIGHT.text2,
                boxShadow: SV_LIGHT.shadowMd,
            },
            '.darkTheme &': {
                backgroundColor: SV_DARK.surfaceMuted,
                borderColor: SV_DARK.text2,
                boxShadow: SV_DARK.shadowMd,
            },
        },
        '&.Mui-disabled': {
            opacity: 0.45,
        },
    }
}
